import React, { useLayoutEffect, useContext } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import MarkdownDataContext from "~contexts/MarkdownDataContext"
import Tab from "./Tab"

// A single tab in a set of tabs
const Component = ({ title, children }) => {
  const microcopy = useContext(MicrocopyContext)
  const data = useContext(MarkdownDataContext)

  const { environments } = microcopy.copy.reference

  // determine the label for the tab, defaulting to
  // the given string. This helps render `dotnet` as `.NET`
  // while also supporting any other environment
  const label = environments[title] || title

  // On first load, register the label. We do
  // this synchronously through useLayoutEffect,
  // as without it would overwrite each set of labels
  useLayoutEffect(() => data.registerLabel(label), [])

  return (
    <Tab label={label} data={data}>
      {children}
    </Tab>
  )
}

export default Component
